import React from 'react'
import HtmlAttrId from 'client/components/core/Sidebar/components/Settings/options/HtmlAttrId'
import { CheckboxControl } from 'src/editor/shared/settings/checkbox-control'
import { TextInputControl } from 'src/editor/shared/settings/controls/text-input-control'
import {
  FormCheckboxInterface,
  FormInterface,
} from 'src/shared/types/entities/form-interface'
import { ColorPickerControl } from 'src/editor/shared/settings/controls/color-picker/color-picker-control'
import { useUpdateFormElementProp } from '../../hooks/use-update-form-element-prop'
import { GroupTitle } from 'src/editor/layout/sidebar/settings/group-title'

export const FormElementCheckboxSettings = ({
  formEntity,
  checkbox,
}: {
  formEntity: FormInterface
  checkbox: FormCheckboxInterface
}) => {
  const updateProp = useUpdateFormElementProp(formEntity, checkbox)

  return (
    <React.Fragment>
      <TextInputControl
        update={updateProp('errorText')}
        value={checkbox.errorText}
        wrapperProps={{
          labelText: 'settings_options.checkbox_message',
        }}
        disabled={checkbox.optional}
      />
      <CheckboxControl
        label="entity_settings.explicit_consent.optional"
        tooltipText="entity_settings.explicit_consent.optional_popover"
        value={checkbox.optional}
        update={updateProp('optional')}
      />

      <GroupTitle></GroupTitle>

      <ColorPickerControl
        update={updateProp('color')}
        mobileUpdate={updateProp('mobileColor')}
        color={checkbox.color}
        mobileColor={checkbox.mobileColor}
        label="text color"
      />
      <HtmlAttrId attrId={checkbox.htmlAttrId} />
    </React.Fragment>
  )
}
